import { j as o } from "../../../jsx-runtime-B6kdoens.js";
import { a as c } from "../../../index-CROKJrb5.js";
import { c as u, f as l } from "../../../create-component-CBAeEoQ6.js";
import { AgencyLogoStickerIcon as p } from "../../Icon/icons/AgencyLogoStickerIcon/index.js";
import { AgencyLogoWordmarkIcon as f } from "../../Icon/icons/AgencyLogoWordmarkIcon/index.js";
import { CurologyLogoLockupIcon as g } from "../../Icon/icons/CurologyLogoLockupIcon/index.js";
import { CurologyLogoStickerIcon as x } from "../../Icon/icons/CurologyLogoStickerIcon/index.js";
import { u as d } from "../../../NavigationState-EOPjgMu1.js";
import { useBrand as j } from "../../../brand/context/index.js";
import { u as A } from "../../../react-B_GApDuV.js";
const L = ({
  isBreakpointCollapsed: r
}) => j() === "curology" ? r ? /* @__PURE__ */ o.jsx(x, { className: "cur-h-10 cur-w-10", size: null }) : /* @__PURE__ */ o.jsx(g, { size: null }) : r ? /* @__PURE__ */ o.jsx(p, { className: "cur-h-10 cur-w-10", size: null }) : /* @__PURE__ */ o.jsx(f, { size: null }), S = u(
  "NavigationBrand",
  l(
    ({ as: r, className: t, href: s, ...n }, e) => {
      const a = r || (s ? "a" : "span"), { isBreakpointCollapsedAtom: i } = d(), m = A(i);
      return /* @__PURE__ */ o.jsx(
        a,
        {
          ref: e,
          href: s,
          className: c("cur-flex cur-items-center", t),
          ...n,
          children: /* @__PURE__ */ o.jsx(L, { isBreakpointCollapsed: m })
        }
      );
    }
  )
);
export {
  S as NavigationBrand
};
//# sourceMappingURL=index.js.map
